(() => {
  const paper = window.DirtPaper ||= {};
  if (paper.shellInitialized) return;
  paper.shellInitialized = true;
  const config = document.querySelector('[data-dirt-config]');
  if (config) {
    try {Object.assign(paper, JSON.parse(config.textContent));}
    catch {document.dispatchEvent(new CustomEvent('dirt:configuration-error'));}
  }
  const menus = new Map();
  function initMenu(root) {
    if (menus.has(root)) return;
    const controller = new AbortController();
    const options = {signal: controller.signal};
    let panel, active = 'wines', lastTrigger;
    const triggers = [...root.querySelectorAll('[data-menu-toggle]')];
    function state() {
      root.toggleAttribute('data-open', !!panel);
      root.toggleAttribute('data-closed', !panel);
      for (const trigger of triggers) {
        const expanded = !!panel && (trigger.dataset.menuToggle === 'mobile' || trigger.dataset.menuToggle === active);
        trigger.setAttribute('aria-expanded', String(expanded));
        trigger.toggleAttribute('data-panel-open', !!panel);
      }
    }
    function close(restore = false) {
      panel?.remove(); panel = null; state();
      if (restore) {
        const trigger = [lastTrigger, ...triggers.filter(t => t.dataset.menuToggle === 'mobile'), ...triggers].find(t => t?.getClientRects().length);
        trigger?.focus({preventScroll: true});
      }
    }
    function open(name) {
      const template = [...root.querySelectorAll('[data-menu-template]')].find(node => node.dataset.menuTemplate === name);
      if (!template) return;
      const focusSwitch = panel?.contains(document.activeElement);
      panel?.remove();
      active = name;
      const content = template.content.cloneNode(true);
      panel = content.firstElementChild;
      panel.setAttribute('data-open', '');
      panel.setAttribute('data-menu-panel', '');
      template.before(content);
      state();
      if (focusSwitch) panel.querySelector('[data-menu-switch], button, a')?.focus({preventScroll: true});
    }
    function accordion(trigger) {
      const item = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!item || !root.contains(item)) return;
      const expanded = trigger.getAttribute('aria-expanded') !== 'true';
      for (const other of panel.querySelectorAll('[data-menu-accordion]')) {
        const target = document.getElementById(other.getAttribute('aria-controls'));
        if (!target || !root.contains(target)) continue;
        const selected = expanded && other === trigger;
        other.setAttribute('aria-expanded', String(selected));
        other.toggleAttribute('data-panel-open', selected);
        other.closest('[data-slot="accordion-item"]')?.toggleAttribute('data-open', selected);
        target.hidden = !selected;
        target.toggleAttribute('data-open', selected);
        target.toggleAttribute('data-closed', !selected);
        if (selected) target.style.setProperty('--accordion-panel-height', `${target.firstElementChild?.scrollHeight || target.scrollHeight}px`);
      }
    }
    root.addEventListener('click', event => {
      const trigger = event.target.closest('[data-menu-toggle]');
      if (trigger) {
        lastTrigger = trigger;
        const name = trigger.dataset.menuToggle === 'mobile' ? active : trigger.dataset.menuToggle;
        if (panel && name === active) close(); else open(name);
      } else if (event.target.closest('[data-menu-close]')) close(true);
      else if (event.target.closest('[data-menu-switch]')) open(event.target.closest('[data-menu-switch]').dataset.menuSwitch);
      else if (event.target.closest('[data-menu-accordion]')) accordion(event.target.closest('[data-menu-accordion]'));
      else if (event.target.closest('[data-dirt-open]')) close();
    }, options);
    root.addEventListener('keydown', event => {
      if (panel && event.key === 'Escape') {event.preventDefault(); event.stopPropagation(); close(true);}
    }, options);
    root.addEventListener('focusout', event => {if (event.relatedTarget && !root.contains(event.relatedTarget)) close();}, options);
    document.addEventListener('pointerdown', event => {if (!root.contains(event.target)) close();}, options);
    menus.set(root, () => {close(); controller.abort(); menus.delete(root);});
    state();
  }
  function init(container = document) {
    if (container.matches?.('[data-dirt-menu]')) initMenu(container);
    container.querySelectorAll('[data-dirt-menu]').forEach(initMenu);
    container.querySelectorAll('.service-navigation').forEach(nav => {
      const item = nav.querySelector('[aria-current="page"]');
      if (item && nav.scrollWidth > nav.clientWidth) nav.scrollLeft = Math.max(0, item.offsetLeft - nav.offsetLeft - 12);
    });
  }
  let lenis, observer;
  function initScroll() {
    if (lenis || !window.Lenis) return;
    lenis = new window.Lenis({autoRaf: true, anchors: true, allowNestedScroll: true, stopInertiaOnNavigate: true, respectReducedMotion: true, syncTouch: false});
    const update = () => {
      const locked = [document.documentElement, document.body].some(node => ['hidden', 'clip'].includes(node.style.overflowY));
      if (locked) lenis.stop(); else lenis.start();
    };
    observer = new MutationObserver(update);
    [document.documentElement, document.body].forEach(node => observer.observe(node, {attributes: true, attributeFilter: ['style']}));
    update();
  }
  paper.scrollTo = (target, {behavior = 'smooth'} = {}) => {
    if (lenis) lenis.scrollTo(target, {immediate: behavior !== 'smooth'});
    else {
      const node = typeof target === 'string' ? document.querySelector(target) : target;
      const motion = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : behavior;
      if (typeof target === 'number') window.scrollTo({top: target, behavior: motion});
      else node?.scrollIntoView({behavior: motion, block: 'start'});
    }
  };
  init(); initScroll();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, destroy] of menus) if (event.target === root || event.target.contains(root)) destroy();
  });
  window.addEventListener('pagehide', () => {observer?.disconnect(); lenis?.destroy(); lenis = null;});
  window.addEventListener('pageshow', () => {init(); initScroll();});
})();
